import React from 'react';
import useDelayedClose from '../hooks/useDelayedClose';
import '../style/solicitorLayoutHeader.css'
import BreadCrumb from './breadcrumb';
import SolicitorHomeSlider from './General/solicitorHomeSlider';
import aragLogo from '../assets/images/araglogo2.png';
import {
	FormGroup,
	NavBar,
	NavBarMain,
	NavContainer,
	NavContent,
	NavHeader,
	NavLink,
	NavUser,
} from 'arag-ui-lib';
import {
	REVERSE, SECONDARY, SOLICITOR,
	HREF_HOME, HREF_NEW_APPLICATION,
	HREF_APPLICATION_AND_POLICIES, HREF_ADVANCE_DISBURSEMENTS,
	HREF_NOTIFICATIONS, HREF_MANAGE_ACCOUNT
} from '../helpers/constants';
import CONTENT_STRINGS from '../helpers/contentStrings';
import { FORM_GROUP_VARIANTS } from '../helpers/formGroupVariants';
import { callbackHandler } from '../helpers/functions';
import useFeatureFlag from '../hooks/useFeatureFlag';
import { FEATURE_FLAGS } from '../constants/configurationKeys';

const SolicitorLayoutHeader = (props) => {

	const {
		push,
		logout,
		locationPathName,
		userRoles,
		solicitorHomePageInfo,
		notificationsIconCount,
		images,
		fetchingImages,
		imageCounter,
		fetchedImageIndexes,
		incrementImageCounter,
		solicitorGroupAllowedToApplyForDisbursements,
		isNavbarOpen,
		setIsNavbarOpen,
		userData,
	} = props;

	const showMobileMenu = useDelayedClose(isNavbarOpen, 300);
	const advanceDisbursementsEnabled = useFeatureFlag(FEATURE_FLAGS.ADVANCE_DISBURSEMENTS_ENABLED);

	let icon = '';
	if (notificationsIconCount !== undefined && notificationsIconCount > 0)
		icon = <span className={'notifications-icon'}>{notificationsIconCount}</span>;

	const logOff = (e) => {
		e.preventDefault();
		logout();
	}
	const extractEmail = (title) => {
		if (!title) return '';
		const hrefMatch = title.match(/href="mailto:([^"]+)"/);
		if (hrefMatch) 
			return <a href={`mailto:${hrefMatch[1]}`} className={"solicitor-layout-header-telephone-section-paragraph-number"}>{hrefMatch[1]}</a>
		else 
			return title;
	};

	const USER_MENU = [
		{
			label: CONTENT_STRINGS.MANAGE_ACCOUNT,
			href: HREF_MANAGE_ACCOUNT,
			callback: (e) => { callbackHandler(e, HREF_MANAGE_ACCOUNT, setIsNavbarOpen, push); },
			testId: 'header-manage-account'
		},
		{
			label: CONTENT_STRINGS.LOG_OFF,
			callback: (e) => { logOff(e); },
			testId: 'header-logoff'
		}
	];

	return (
		<div className={'row solicitor-layout-row print'}>
			<div className={'col-sm-12 solicitor-layout-header-wrapper'}>
				<NavBar variant={SECONDARY}>
					<NavContainer navContainerTestId={'header'} variant={SECONDARY}>
						<NavHeader
							href={HREF_HOME}
							onBarsClick={() => setIsNavbarOpen(!isNavbarOpen)}
							onClick={(e) => { callbackHandler(e, HREF_HOME, setIsNavbarOpen, push); }}
							navHeaderTestId={'header-logo'}
							variant={SECONDARY}
						>
							<img className={'solicitor-layout-header-logo'} src={aragLogo} alt={'arag logo'} />
						</NavHeader>
						<NavContent expanded={isNavbarOpen} variant={SECONDARY} onClose={() => setIsNavbarOpen(false)}>
							<NavBarMain navBarTestId={'header-nav-bar'} variant={SECONDARY}>
								{
									userRoles.includes(SOLICITOR)
									?
										<NavLink
											href={HREF_NEW_APPLICATION}
											onClick={(e) => { callbackHandler(e, HREF_NEW_APPLICATION, setIsNavbarOpen, push); }}
											navLinkTestId={'header-new-application'}
											variant={SECONDARY}
											active={locationPathName === HREF_NEW_APPLICATION}
										>
											{CONTENT_STRINGS.NEW_APPLICATION}
										</NavLink>
									:
										null
								}
								{
									userRoles.includes(SOLICITOR)
									?
										<NavLink
											href={HREF_APPLICATION_AND_POLICIES}
											onClick={(e) => { callbackHandler(e, HREF_APPLICATION_AND_POLICIES, setIsNavbarOpen, push); }}
											navLinkTestId={'header-applications'}
											variant={SECONDARY}
											active={locationPathName === HREF_APPLICATION_AND_POLICIES}
										>
											{CONTENT_STRINGS.APPLICATIONS_AND_POLICIES}
										</NavLink>
									:
										null
								}
								{
									solicitorGroupAllowedToApplyForDisbursements && advanceDisbursementsEnabled
									?
										<NavLink
											href={HREF_ADVANCE_DISBURSEMENTS}
											onClick={(e) => { callbackHandler(e, HREF_ADVANCE_DISBURSEMENTS, setIsNavbarOpen, push); }}
											navLinkTestId={'header-advance-disbursements'}
											variant={SECONDARY}
											active={locationPathName === HREF_ADVANCE_DISBURSEMENTS}
										>
											{CONTENT_STRINGS.ADVANCE_DISBURSEMENTS}
										</NavLink>
									:
										null
								}
								{
									userRoles.includes(SOLICITOR)
									?
										<NavLink
											href={HREF_NOTIFICATIONS}
											onClick={(e) => { callbackHandler(e, HREF_NOTIFICATIONS, setIsNavbarOpen, push); }}
											navLinkTestId={'header-notifications'}
											variant={SECONDARY}
											active={locationPathName === HREF_NOTIFICATIONS}
										>
											{CONTENT_STRINGS.NOTIFICATIONS} {icon}
										</NavLink>
									:
										null
								}
							</NavBarMain>
							{
								showMobileMenu
								?
									USER_MENU.map((item) => (
										<div key={item.testId}>
											<NavLink
												href={item.href}
												onClick={item.callback}
												navLinkTestId={item.testId}
												variant={SECONDARY}
												active={locationPathName === item.href}
											>
												{item.label}
											</NavLink>
										</div>
									))
								:
									<NavUser
										id={'user-menu'}
										dropdownLabel={userData.username}
										options={USER_MENU}
										navUserTestId={'header-user'}
										variant={SECONDARY}
									/>
							}
						</NavContent>
					</NavContainer>
				</NavBar>
			</div>
			<div className={'row'}>
				<div className={'col-sm-12'}>
					<SolicitorHomeSlider
						fetchingImages={fetchingImages}
						imageCounter={imageCounter}
						fetchedImageIndexes={fetchedImageIndexes}
						incrementImageCounter={incrementImageCounter}
						images={images}
					/>
				</div>
			</div>
			<div className={'row'}>
				<div className={'col-sm-12'}>
					<div className={'solicitor-layout-header-telephone-section'}>
						{
							solicitorHomePageInfo.map((item, index) => {
								const landingPageSeparator = index < solicitorHomePageInfo.length - 1 
									? <div className={'solicitor-layout-vertical-rule'}></div> 
									: null;
								const label = extractEmail(item.title);
								return (
									<div key={index}>
										<FormGroup
											labelSize={'col-sm-12 solicitor-layout-header-telephone-section-paragraph-number'}
											inputSize={'col-sm-12 solicitor-layout-header-telephone-section-paragraph-description'}
											label={item.body}
											variant={FORM_GROUP_VARIANTS.PLAIN}
											inputProps={{
												name: 'landingInfo' + index,
												label: label,
											}}
											groupShape={REVERSE}
											hasInlineElements={true}
											inlineGroupElements={landingPageSeparator}
											formGroupTestId={`solicitor-home-contacts-bar-item-${index}`}
										/>
									</div>
								)
							})
						}
					</div>
				</div>
			</div>
			<div className={'row'}>
				<div className={'col-sm-12'}>
					<BreadCrumb
						PathName={locationPathName}
						Push={push}
						BreadcrumbStyle={'user-layout-footer-breadcrumb'}
						Wrapper={'user-layout-footer-breadcrumb-wrapper'}
						breadcrumbTestId={'header-breadcrumb'}
					/>
				</div>
			</div>
		</div>
	)
};

export default SolicitorLayoutHeader;
